const STORAGE_KEY = 'tlp.rider.theme';

export type ThemeMode = 'light' | 'dark';

/**
 * Light or dark, and the ability to choose.
 *
 * Dark SHIPS in this app, unlike the customer one. A rider works evenings and
 * reads this at a doorway with the screen at full brightness; a cream page at
 * 9pm is the difference between reading an address and shielding the phone
 * with a hand that is already holding a bag.
 *
 * The attribute is written by the boot script in index.html before first
 * paint. Everything here agrees with it rather than deciding again — the value
 * is read back off the DOM, so there is exactly one source of truth and no
 * flash of the wrong ground on load.
 */
export function currentTheme(): ThemeMode {
  return document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light';
}

export function applyTheme(mode: ThemeMode) {
  document.documentElement.dataset.theme = mode;
  document.documentElement.style.colorScheme = mode;

  /*
   * The browser chrome has to track the page, or a dark app gets a cream bar
   * above it on a phone and reads as two applications. The two literals are
   * the one place a token value is repeated in this app: `theme-color` is a
   * meta tag and cannot read a CSS variable. They are `surface.page` in each
   * theme — keep them in step with tokens/colors.json.
   */
  const meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (meta) meta.content = mode === 'dark' ? '#131312' : '#FDFDFB';

  try {
    window.localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // Storage blocked. The choice holds for this page load and no longer,
    // which is better than refusing to switch at all.
  }
}
